import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import {of as observableOf, Observable} from 'rxjs';
import {catchError} from 'rxjs/operators';

import { AppPermissionsService } from '../../services/app-permissions/app-permissions.service';
import { DeocsPermissionsService } from '../../deocs/deocs-permissions/deocs-permissions.service';

@Injectable({
  providedIn: 'root'
})
export class EcaHasAppViewPermissionGuard  {
  private _appPermissionsService = inject(AppPermissionsService);
  private _deocsPermissionsService = inject(DeocsPermissionsService);
  private _router = inject(Router);


  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {

    const moduleName = route.data && route.data.module ? route.data.module : 'eca-security-service';

    let truthyObservable = this._appPermissionsService.canViewApplication();
    if (moduleName === 'deocs') {
      truthyObservable = this._deocsPermissionsService.canViewApplication();
    }

    return this._appPermissionsService.controlTruthyObservable(truthyObservable).pipe(
      catchError(() => {
        this._router.navigateByUrl('/denied');
        return observableOf(false);
      }));
  }
}
